//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from "moment";
export default {
  name: "MedicamentConfigureModal",
  data: function data() {
    return {
      title: "操作",
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请输入站点ID!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入配置人员!'
          }]
        },
        configureDate: {
          rules: [{
            required: true,
            message: '请输入配置时间!'
          }]
        },
        drugName: {
          rules: [{
            required: true,
            message: '请输入药品名称!'
          }]
        },
        drugUsage: {
          rules: [{
            required: true,
            message: '请输入药品使用量!'
          }]
        },
        use: {
          rules: [{
            required: true,
            message: '请输入药剂用途!'
          }]
        }
      },
      url: {
        add: "/om/medicament/configure/add",
        edit: "/om/medicament/configure/edit"
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'siteId', 'userId', 'configureDate', 'drugName', 'drugUsage', 'useUnit', 'use', 'parameters', 'concentration', 'concentrationUnit', 'dosage', 'dosageUnit', 'remark', 'createBy', 'createTime', 'updateBy', 'updateTime', 'tenantId')); //时间格式化


        _this.form.setFieldsValue({
          configureDate: _this.model.configureDate ? moment(_this.model.configureDate) : null
        });

        _this.form.setFieldsValue({
          createTime: _this.model.createTime ? moment(_this.model.createTime) : null
        });

        _this.form.setFieldsValue({
          updateTime: _this.model.updateTime ? moment(_this.model.updateTime) : null
        });
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl += _this2.url.add;
            method = 'post';
          } else {
            httpurl += _this2.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this2.model, values); //时间格式化

          formData.configureDate = formData.configureDate ? formData.configureDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.createTime = formData.createTime ? formData.createTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.updateTime = formData.updateTime ? formData.updateTime.format('YYYY-MM-DD HH:mm:ss') : null;
          console.log(formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
              that.close();
            } else {
              that.$message.warning(res.message);
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};